var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTelephoneIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 64C49.6732 64 64 49.6732 64 32C64 14.3268 49.6732 0 32 0C14.3268 0 0 14.3268 0 32C0 49.6732 14.3268 64 32 64ZM17.5794 14.2682C14.9661 15.6569 13.3327 18.3743 13.3333 21.3333C13.3333 37.5339 26.4661 50.6667 42.6667 50.6667C45.625 50.6673 48.3418 49.0352 49.7311 46.4238C51.1198 43.8125 50.9551 40.6471 49.3014 38.1947L37.9837 36.1947L34.6771 42.5332C28.5905 40.2253 23.7852 35.4199 21.4772 29.3333L27.8105 26.0202L25.8105 14.7025C23.3581 13.0462 20.1921 12.8796 17.5794 14.2682Z",
    fill: "#33CA8F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelephoneIcon);
export default __webpack_public_path__ + "static/media/telephone-icon.a2a7221e077180cf6a0b17dcb71a80cc.svg";
export { ForwardRef as ReactComponent };